import { z } from "zod";

export const dossierSchema = z.object({
  soort: z.enum(["bemiddeling", "zakelijk", "nen", "foto"]),
  titel: z.string().trim().min(1).max(200),
  inhoud: z.object({
    toelichting: z.string().trim().max(4000).optional(),
    aanvraag_id: z.string().uuid().optional(),
    antwoorden: z.array(z.enum(["ja", "nee", "onbekend"])).length(4).optional(),
    fotos: z.array(z.object({ naam: z.string().max(200), url: z.string().max(4_200_000).regex(/^data:image\/(jpeg|png|webp);base64,[A-Za-z0-9+/=]+$/) })).max(3).optional(),
  }).strict(),
}).strict();

export const documentSchema = z.object({
  user_id: z.string().uuid(),
  lead_id: z.string().uuid(),
  soort: z.enum(["offerte", "factuur"]),
  titel: z.string().trim().min(1).max(200),
  bestandsnaam: z.string().min(1).max(200),
  bestand: z.string().max(4_200_000).regex(/^data:application\/pdf;base64,JVBER[A-Za-z0-9+/=]+$/),
});

export const nenVragen = [
  "Zijn er brandlucht, rook, vonken of ongewoon warme onderdelen?",
  "Zijn draden of elektrische onderdelen beschadigd of onbeschermd bereikbaar?",
  "Vallen groepen of de aardlekschakelaar herhaaldelijk uit?",
  "Is de installatie recent aangepast zonder oplever- of inspectierapport?",
] as const;

export function nenAdvies(antwoorden: readonly string[]) {
  if (antwoorden.length !== 4 || antwoorden.some((a) => !["ja", "nee", "onbekend"].includes(a))) throw new Error("Beantwoord alle vragen.");
  if (antwoorden[0] === "ja") return { niveau: "urgent", titel: "Mogelijk direct gevaar", tekst: "Raak de installatie niet aan. Bij rook, brand of direct gevaar: houd afstand en bel 112. Laat een elektricien de situatie beoordelen." };
  if (antwoorden.some((a) => a === "ja")) return { niveau: "controle", titel: "Laat je installatie beoordelen", tekst: "Je antwoorden geven aanleiding voor controle door een bevoegde elektricien. Open de groepenkast niet zelf en werk niet aan spanningvoerende onderdelen." };
  return { niveau: "informatief", titel: "Een inspectie blijft nodig voor zekerheid", tekst: "Met deze antwoorden is veiligheid of naleving van NEN niet vast te stellen. Ook zonder zichtbare problemen zijn metingen en beoordeling door een deskundige nodig." };
}

export const accountOnderdelen = ["chat", "installateur", "kennisbank", "calculatoren", "nen-check", "bemiddeling", "offertes", "facturen", "camera", "zakelijk", "nieuws", "meer", "meldingen"] as const;
export type AccountOnderdeel = typeof accountOnderdelen[number];
export function accountHead(titel: string, beschrijving: string) {
  return { meta: [{ title: `${titel} | Mijn offerto` }, { name: "description", content: beschrijving }, { property: "og:title", content: `${titel} | Mijn offerto` }, { property: "og:description", content: beschrijving }, { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary" }, { name: "robots", content: "noindex, nofollow" }] };
}